import { computed, defineComponent, useCssModule, useContext, reactive } from '@nuxtjs/composition-api';
import { createShareImage } from '~/utils';
import { useA11y } from '~/composables';
export default defineComponent({
    name: 'ArticleHeader',
    props: {
        article: {
            default: () => ({}),
            type: Object,
        },
        schemaDisabled: {
            default: false,
            type: Boolean,
        },
    },
    setup(props) {
        /**
         * Accessibility
         */
        const a11y = useA11y();
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        /**
         * Context.
         */
        const context = useContext();
        /**
         * Environment variables.
         */
        const env = context.env;
        /**
         * Viewport.
         */
        const viewport = context.$viewport;
        /**
         * Article Actions
         */
        const articleActions = reactive({
            actions: computed(() => {
                const tooltipJustify = viewport.isLessThan('tablet') ? 'end' : 'center';
                const { id, changed, erid, url_alias: path } = props.article;
                let url = `${env.HOST || ''}/${path}`;
                url = erid ? url + `?erid=${erid}` : url;
                return [
                    'a11y',
                    {
                        speech: {
                            tooltip: true,
                            isTooltipBanner: true,
                        },
                    },
                    {
                        share: {
                            tooltipJustify,
                            'v-if': !a11y.modes.text.isEnabled,
                            url,
                            vkImage: createShareImage({
                                article: { id, changed },
                                env,
                                isVk: true,
                            }),
                            withCopyLink: viewport.isLessThan('tablet'),
                        },
                    },
                    {
                        bookmark: {
                            article: props.article.url_alias,
                            tooltip: true,
                        },
                    },
                ];
            }),
            theme: computed(() => (a11y.isEnabled ? 'a11y' : 'light')),
            withShadow: false,
        });
        const franchiseLabel = computed(() => {
            const { subscriptions = [] } = props.article || {};
            if (!subscriptions?.length) {
                return null;
            }
            const { tariff = {} } = subscriptions.find((item) => item.tariff) || {};
            return tariff?.profitable;
        });
        const currentEventDate = computed(() => {
            if (!props.article.date) {
                return {};
            }
            const date = new Date(props.article.date * 1000);
            if (isNaN(date.getTime())) {
                return {};
            }
            return {
                day: date.toLocaleDateString('ru-RU', { day: 'numeric' }),
                month: date.toLocaleDateString('ru-RU', { month: 'long' }),
                weekday: date.toLocaleDateString('ru-RU', { weekday: 'long' }),
            };
        });
        return {
            a11y,
            articleActions,
            css,
            franchiseLabel,
            currentEventDate,
        };
    },
});
